import { useLanguageTranslation } from "../../hooks/useLanguageTranslation";

const PageLastUpdated = ({ lastUpdatedOn }) => {
  const { getText } = useLanguageTranslation();

  return (
    <div style={{ display: "flex", justifyContent: "end" }}>
      <p>
        <strong>{getText("Page Last Updated : ", "आखिरी अपडेट : ")}</strong>
        {lastUpdatedOn === "Input is not a valid object" ||
        lastUpdatedOn === null
          ? "N/A"
          : lastUpdatedOn}
      </p>
    </div>
  );
};

export default PageLastUpdated;
